"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var YandexRuSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M6.89923707,6.69554404 C6.89923707,4.4146114 8.20932402,3 10.0576408,3 L12,3 L12,14 L10.6810411,14 L10.6810411,9.98585494 L10.0824822,9.98585494 L7.9614283,14 L6.34285729,14 L8.76234038,9.73792743 C7.56167382,9.18792743 6.89923707,8.11357511 6.89923707,6.69554404 Z M10.6810411,4.09487046 L10.0126898,4.09487046 C9.01903465,4.09487046 8.30750664,4.96404145 8.30750664,6.55134715 C8.30750664,8.07025907 9.06457716,8.89098447 10.1469515,8.89098447 L10.6810411,8.89098447 L10.6810411,4.09487046 Z" })));
};
YandexRuSmall.displayName = 'YandexRuSmall';
exports.default = YandexRuSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=YandexRuSmall.js.map